import { render, staticRenderFns } from "./PromotionDescription.vue?vue&type=template&id=f88e5a72&"
import script from "./PromotionDescription.vue?vue&type=script&lang=ts&"
export * from "./PromotionDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports